import { gql } from "@apollo/client";
import { CRM_TASK_FIELDS_FRAGMENT } from "@/fragments";
import type { CRMTask, TaskStage, TaskVisibility } from "@/types";

export const UPDATE_TASK_MUTATION = gql`
  mutation UpdateTask($input: BackofficeCRMUpdateTaskInput!) {
    updateTask(input: $input) {
      code
      success
      message
      task {
        ...CRMTaskFields
      }
    }
  }
  ${CRM_TASK_FIELDS_FRAGMENT}
`;

export type UpdateTaskResponse = {
  updateTask: {
    code: string;
    success: boolean;
    message: string | null;
    task: CRMTask | null;
  };
};

export type BackofficeCRMUpdateTaskInput = {
  id: string;
  name?: string;
  description?: string;
  stage?: TaskStage;
  assignedToId?: string | null;
  dueDate?: string | null;
  visibility?: TaskVisibility;
  teamTags?: string[];
};

export type BackofficeCRMUpdateTaskFields = Omit<BackofficeCRMUpdateTaskInput, "id">;

export const DELETE_TASK_MUTATION = gql`
  mutation DeleteTask($taskId: ID!) {
    deleteTask(taskId: $taskId) {
      code
      success
      message
    }
  }
`;

export type DeleteTaskResponse = {
  deleteTask: {
    code: string;
    success: boolean;
    message: string | null;
  };
};
